import React from "react"
import styled, { css } from "styled-components"
import { AppFunctionComponent } from "../../types"
import { markedTextStyles } from "./general-styles.component"

const AppHeading = styled.span``

type HeadingTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "div"

interface Props {
  renderAs: HeadingTag
  children?: React.ReactNode
  className?: string
}

const Heading: AppFunctionComponent<Props> = ({
  className = "",
  children,
  renderAs,
}) => (
  <AppHeading as={renderAs} className={className}>
    {children}
  </AppHeading>
)

const createHeadingWithDefaultTag =
  (defaultTag: HeadingTag) =>
  ({ renderAs = defaultTag, ...props }) =>
    <Heading renderAs={renderAs} {...props} />

const headingStyles = css`
  font-weight: 400;
  color: ${({ theme }) => theme.color.textDisplay};
  font-family: Facto, Arial, Helvetica, Gill Sans, Lucida, Helvetica Narrow,
    sans-serif;

  u {
    ${markedTextStyles};
  }
`

export const primaryHeadingStyles = css`
  ${headingStyles};

  font-size: ${30 / 16}rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    font-size: ${37 / 16}rem;
  }
`

export const PrimaryHeading = styled(createHeadingWithDefaultTag("h1"))`
  ${primaryHeadingStyles};
`

export const secondaryHeadingStyles = css`
  ${headingStyles};

  line-height: 1.5;
  font-weight: 500;
  font-size: ${18 / 16}rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    font-size: ${23 / 16}rem;
  }
`

export const SecondaryHeading = styled(createHeadingWithDefaultTag("h2"))`
  ${secondaryHeadingStyles};
`

export const tertiaryHeadingStyles = css`
  ${headingStyles};

  font-size: ${18 / 16}rem;
  line-height: 2;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    font-size: ${20 / 16}rem;
    line-height: 1.5;
  }
`

export const TertiaryHeading = styled(createHeadingWithDefaultTag("h3"))`
  ${tertiaryHeadingStyles};
`

export const quaternaryHeadingStyles = css`
  ${headingStyles};

  font-size: 1rem;
  line-height: 2;
`

export const QuaternaryHeading = styled(createHeadingWithDefaultTag("h4"))`
  ${quaternaryHeadingStyles};
`

export const quinaryHeadingStyles = css`
  ${headingStyles};

  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    font-size: ${18 / 16}rem;
    line-height: 1.5;
  }
`

export const QuinaryHeading = styled(createHeadingWithDefaultTag("h5"))`
  ${quinaryHeadingStyles};
`

export const senaryHeadingStyles = css`
  ${headingStyles};

  font-size: ${15 / 16}rem;
  font-weight: 500;
  line-height: 1.5;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    font-size: ${15 / 16}rem;
    line-height: 1.5;
  }
`

export const SenaryHeading = styled(createHeadingWithDefaultTag("h6"))`
  ${senaryHeadingStyles};
`
